/**
 * Grandstream PBX API Mock Data Layer
 * Mock data structured following Grandstream UCM HTTPS API response formats: { status: 0, response: ... }
 */

export const mockDashboardData = {
  status: 0,
  response: {
    totalExtensions: 120,
    registeredExtensions: 108,
    activeCalls: 14,
    todaysCalls: 452,
    missedCalls: 28,
    answeredCalls: 405,
    failedCalls: 19,
    avgCallDuration: "03m 45s",
    callsPerHour: [
      { hour: "08:00", calls: 24 },
      { hour: "09:00", calls: 68 },
      { hour: "10:00", calls: 95 },
      { hour: "11:00", calls: 82 },
      { hour: "12:00", calls: 45 },
      { hour: "13:00", calls: 58 },
      { hour: "14:00", calls: 89 },
      { hour: "15:00", calls: 76 },
      { hour: "16:00", calls: 62 },
      { hour: "17:00", calls: 30 }
    ],
    callsByStatus: [
      { status: "Answered", count: 405, color: "#2e7d32" },
      { status: "Missed", count: 28, color: "#ed6c02" },
      { status: "Failed", count: 19, color: "#d32f2f" },
      { status: "Busy", count: 12, color: "#0288d1" }
    ],
    callsByExtension: [
      { extension: "1001 - John Doe", count: 48 },
      { extension: "1002 - Jane Smith", count: 42 },
      { extension: "1003 - Robert Johnson", count: 35 },
      { extension: "1004 - Emily Davis", count: 31 },
      { extension: "1005 - Michael Brown", count: 27 },
      { extension: "1006 - Sarah Wilson", count: 22 }
    ],
    recentCalls: [
      {
        callId: "CDR-98421",
        caller: "+1 (555) 234-5678",
        callee: "1001 (John Doe)",
        extension: "1001",
        direction: "Inbound",
        startTime: "2026-07-20 15:42:10",
        endTime: "2026-07-20 15:45:32",
        duration: "03m 22s",
        status: "Answered",
        recording: "rec_98421.wav",
        trunk: "Trunk_SIP_Primary"
      },
      {
        callId: "CDR-98420",
        caller: "1004 (Emily Davis)",
        callee: "+1 (555) 987-6543",
        extension: "1004",
        direction: "Outbound",
        startTime: "2026-07-20 15:38:00",
        endTime: "2026-07-20 15:41:15",
        duration: "03m 15s",
        status: "Answered",
        recording: "rec_98420.wav",
        trunk: "Trunk_SIP_Secondary"
      },
      {
        callId: "CDR-98419",
        caller: "+1 (555) 888-1234",
        callee: "Queue 8000 (Sales)",
        extension: "1002",
        direction: "Inbound",
        startTime: "2026-07-20 15:35:12",
        endTime: "2026-07-20 15:35:50",
        duration: "00m 38s",
        status: "Missed",
        recording: null,
        trunk: "Trunk_SIP_Primary"
      },
      {
        callId: "CDR-98418",
        caller: "1003 (Robert Johnson)",
        callee: "1005 (Michael Brown)",
        extension: "1003",
        direction: "Internal",
        startTime: "2026-07-20 15:20:00",
        endTime: "2026-07-20 15:28:45",
        duration: "08m 45s",
        status: "Answered",
        recording: "rec_98418.wav",
        trunk: "Local"
      },
      {
        callId: "CDR-98417",
        caller: "+1 (555) 444-9999",
        callee: "RingGroup 9001",
        extension: "1006",
        direction: "Inbound",
        startTime: "2026-07-20 15:10:05",
        endTime: "2026-07-20 15:10:20",
        duration: "00m 15s",
        status: "Failed",
        recording: null,
        trunk: "Trunk_SIP_Primary"
      }
    ]
  }
};

export const mockCallHistoryData = {
  status: 0,
  response: [
    {
      callId: "CDR-98421",
      caller: "+1 (555) 234-5678",
      callee: "1001 (John Doe)",
      extension: "1001",
      direction: "Inbound",
      startTime: "2026-07-20 15:42:10",
      endTime: "2026-07-20 15:45:32",
      duration: "03m 22s",
      durationSec: 202,
      status: "Answered",
      recording: "rec_98421.wav",
      recordingUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3",
      trunk: "Trunk_SIP_Primary"
    },
    {
      callId: "CDR-98420",
      caller: "1004 (Emily Davis)",
      callee: "+1 (555) 987-6543",
      extension: "1004",
      direction: "Outbound",
      startTime: "2026-07-20 15:38:00",
      endTime: "2026-07-20 15:41:15",
      duration: "03m 15s",
      durationSec: 195,
      status: "Answered",
      recording: "rec_98420.wav",
      recordingUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3",
      trunk: "Trunk_SIP_Secondary"
    },
    {
      callId: "CDR-98419",
      caller: "+1 (555) 888-1234",
      callee: "Queue 8000 (Sales)",
      extension: "1002",
      direction: "Inbound",
      startTime: "2026-07-20 15:35:12",
      endTime: "2026-07-20 15:35:50",
      duration: "00m 38s",
      durationSec: 38,
      status: "Missed",
      recording: null,
      recordingUrl: null,
      trunk: "Trunk_SIP_Primary"
    },
    {
      callId: "CDR-98418",
      caller: "1003 (Robert Johnson)",
      callee: "1005 (Michael Brown)",
      extension: "1003",
      direction: "Internal",
      startTime: "2026-07-20 15:20:00",
      endTime: "2026-07-20 15:28:45",
      duration: "08m 45s",
      durationSec: 525,
      status: "Answered",
      recording: "rec_98418.wav",
      recordingUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3",
      trunk: "Local"
    },
    {
      callId: "CDR-98417",
      caller: "+1 (555) 444-9999",
      callee: "RingGroup 9001",
      extension: "1006",
      direction: "Inbound",
      startTime: "2026-07-20 15:10:05",
      endTime: "2026-07-20 15:10:20",
      duration: "00m 15s",
      durationSec: 15,
      status: "Failed",
      recording: null,
      recordingUrl: null,
      trunk: "Trunk_SIP_Primary"
    },
    {
      callId: "CDR-98416",
      caller: "+1 (555) 777-3311",
      callee: "1001 (John Doe)",
      extension: "1001",
      direction: "Inbound",
      startTime: "2026-07-20 14:50:00",
      endTime: "2026-07-20 14:56:10",
      duration: "06m 10s",
      durationSec: 370,
      status: "Answered",
      recording: "rec_98416.wav",
      recordingUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-4.mp3",
      trunk: "Trunk_SIP_Primary"
    },
    {
      callId: "CDR-98415",
      caller: "1007 (Alex Turner)",
      callee: "+1 (555) 321-7654",
      extension: "1007",
      direction: "Outbound",
      startTime: "2026-07-20 14:30:15",
      endTime: "2026-07-20 14:32:00",
      duration: "01m 45s",
      durationSec: 105,
      status: "Busy",
      recording: null,
      recordingUrl: null,
      trunk: "Trunk_SIP_Secondary"
    },
    {
      callId: "CDR-98414",
      caller: "+1 (555) 111-2222",
      callee: "1008 (David Miller)",
      extension: "1008",
      direction: "Inbound",
      startTime: "2026-07-20 14:15:00",
      endTime: "2026-07-20 14:25:30",
      duration: "10m 30s",
      durationSec: 630,
      status: "Answered",
      recording: "rec_98414.wav",
      recordingUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-5.mp3",
      trunk: "Trunk_SIP_Primary"
    }
  ]
};

export const mockActiveCallsData = {
  status: 0,
  response: [
    {
      id: "ACT-101",
      caller: "+1 (555) 678-9012",
      callee: "1001 (John Doe)",
      extension: "1001",
      state: "In Call",
      duration: "04m 12s",
      durationSec: 252,
      direction: "Inbound",
      trunk: "Trunk_SIP_Primary"
    },
    {
      id: "ACT-102",
      caller: "1002 (Jane Smith)",
      callee: "+1 (555) 345-6789",
      extension: "1002",
      state: "Ringing",
      duration: "00m 18s",
      durationSec: 18,
      direction: "Outbound",
      trunk: "Trunk_SIP_Secondary"
    },
    {
      id: "ACT-103",
      caller: "+1 (555) 890-1234",
      callee: "Queue 8000 (Sales)",
      extension: "1004",
      state: "On Hold",
      duration: "02m 45s",
      durationSec: 165,
      direction: "Inbound",
      trunk: "Trunk_SIP_Primary"
    },
    {
      id: "ACT-104",
      caller: "1003 (Robert Johnson)",
      callee: "1005 (Michael Brown)",
      extension: "1003",
      state: "Transferring",
      duration: "01m 05s",
      durationSec: 65,
      direction: "Internal",
      trunk: "Local"
    }
  ]
};

export const mockExtensionsData = {
  status: 0,
  response: [
    {
      id: "ext-1001",
      extension: "1001",
      name: "John Doe",
      status: "Registered",
      registration: "192.168.1.105:5060 (Grandstream GXP2170)",
      department: "Sales",
      email: "john.doe@company.com",
      forwardStatus: true,
      forwardType: "Always",
      forwardNumber: "1002",
      enabled: true
    },
    {
      id: "ext-1002",
      extension: "1002",
      name: "Jane Smith",
      status: "Registered",
      registration: "192.168.1.110:5060 (Grandstream GRP2615)",
      department: "Support",
      email: "jane.smith@company.com",
      forwardStatus: false,
      forwardType: "No Answer",
      forwardNumber: "+15550001111",
      enabled: true
    },
    {
      id: "ext-1003",
      extension: "1003",
      name: "Robert Johnson",
      status: "Unregistered",
      registration: "Offline",
      department: "Engineering",
      email: "robert.j@company.com",
      forwardStatus: true,
      forwardType: "Unavailable",
      forwardNumber: "1001",
      enabled: true
    },
    {
      id: "ext-1004",
      extension: "1004",
      name: "Emily Davis",
      status: "Registered",
      registration: "192.168.1.125:5060 (Grandstream Wave App)",
      department: "Sales",
      email: "emily.davis@company.com",
      forwardStatus: false,
      forwardType: "Busy",
      forwardNumber: "8000",
      enabled: true
    },
    {
      id: "ext-1005",
      extension: "1005",
      name: "Michael Brown",
      status: "Registered",
      registration: "192.168.1.130:5060 (Grandstream GXP1625)",
      department: "Management",
      email: "michael.b@company.com",
      forwardStatus: false,
      forwardType: "Always",
      forwardNumber: "",
      enabled: true
    },
    {
      id: "ext-1006",
      extension: "1006",
      name: "Sarah Wilson",
      status: "Unregistered",
      registration: "Offline",
      department: "HR",
      email: "sarah.w@company.com",
      forwardStatus: false,
      forwardType: "No Answer",
      forwardNumber: "",
      enabled: false
    }
  ]
};

export const mockForwardingData = {
  status: 0,
  response: [
    {
      id: "fwd-1001",
      extension: "1001",
      name: "John Doe",
      forwardType: "Always",
      forwardNumber: "+1 (555) 999-8888",
      status: true
    },
    {
      id: "fwd-1002",
      extension: "1002",
      name: "Jane Smith",
      forwardType: "Busy",
      forwardNumber: "1004",
      status: true
    },
    {
      id: "fwd-1003",
      extension: "1003",
      name: "Robert Johnson",
      forwardType: "No Answer",
      forwardNumber: "+1 (555) 444-3333",
      status: false
    },
    {
      id: "fwd-1004",
      extension: "1004",
      name: "Emily Davis",
      forwardType: "Unavailable",
      forwardNumber: "8000",
      status: true
    },
    {
      id: "fwd-1005",
      extension: "1005",
      name: "Michael Brown",
      forwardType: "Always",
      forwardNumber: "1001",
      status: false
    }
  ]
};

export const mockInboundRoutesData = {
  status: 0,
  response: [
    {
      id: "in-1",
      routeName: "Main Company Line",
      did: "+1 (555) 100-0000",
      destination: "IVR Main Menu (7000)",
      priority: 1,
      status: true
    },
    {
      id: "in-2",
      routeName: "Sales Direct Line",
      did: "+1 (555) 100-0001",
      destination: "Queue Sales (8000)",
      priority: 1,
      status: true
    },
    {
      id: "in-3",
      routeName: "Support Helpdesk",
      did: "+1 (555) 100-0002",
      destination: "RingGroup Support (9001)",
      priority: 2,
      status: true
    },
    {
      id: "in-4",
      routeName: "Executive VIP Direct",
      did: "+1 (555) 100-0009",
      destination: "Extension 1005 (Michael Brown)",
      priority: 1,
      status: false
    }
  ]
};

export const mockOutboundRoutesData = {
  status: 0,
  response: [
    {
      id: "out-1",
      route: "Local & National Calls",
      pattern: "9_NXXNXXXXXX",
      trunk: "Trunk_SIP_Primary",
      priority: 1,
      status: true
    },
    {
      id: "out-2",
      route: "International Calls",
      pattern: "9_011.",
      trunk: "Trunk_SIP_Secondary",
      priority: 2,
      status: true
    },
    {
      id: "out-3",
      route: "Emergency Services",
      pattern: "911",
      trunk: "Trunk_SIP_Primary",
      priority: 1,
      status: true
    },
    {
      id: "out-4",
      route: "Toll-Free Numbers",
      pattern: "9_1800NXXXXXX",
      trunk: "Trunk_SIP_Primary",
      priority: 3,
      status: false
    }
  ]
};

export const mockRingGroupsData = {
  status: 0,
  response: [
    {
      id: "rg-9001",
      groupName: "Sales Team Ring",
      extension: "9001",
      members: ["1001", "1002", "1004"],
      ringStrategy: "RingAll",
      status: true
    },
    {
      id: "rg-9002",
      groupName: "Tech Support Tier 1",
      extension: "9002",
      members: ["1003", "1006"],
      ringStrategy: "Hunt",
      status: true
    },
    {
      id: "rg-9003",
      groupName: "Management Escalation",
      extension: "9003",
      members: ["1005"],
      ringStrategy: "Memory",
      status: false
    }
  ]
};

export const mockQueuesData = {
  status: 0,
  response: [
    {
      id: "q-8000",
      queueNumber: "8000",
      queueName: "Customer Support Queue",
      agents: ["1001", "1002", "1003", "1004"],
      strategy: "LeastRecent",
      waitingCalls: 3,
      status: true
    },
    {
      id: "q-8001",
      queueNumber: "8001",
      queueName: "Inbound Sales Line",
      agents: ["1001", "1004"],
      strategy: "RingAll",
      waitingCalls: 0,
      status: true
    },
    {
      id: "q-8002",
      queueNumber: "8002",
      queueName: "Billing & Inquiries",
      agents: ["1002", "1006"],
      strategy: "Random",
      waitingCalls: 1,
      status: false
    }
  ]
};

export const mockRecordingsData = {
  status: 0,
  response: [
    {
      id: "rec-001",
      recordingName: "rec_98421_1001_inbound.mp3",
      caller: "+1 (555) 234-5678",
      receiver: "1001 (John Doe)",
      date: "2026-07-20 15:42:10",
      duration: "03m 22s",
      fileSize: "3.2 MB",
      url: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3"
    },
    {
      id: "rec-002",
      recordingName: "rec_98420_1004_outbound.mp3",
      caller: "1004 (Emily Davis)",
      receiver: "+1 (555) 987-6543",
      date: "2026-07-20 15:38:00",
      duration: "03m 15s",
      fileSize: "3.1 MB",
      url: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3"
    },
    {
      id: "rec-003",
      recordingName: "rec_98418_1003_internal.mp3",
      caller: "1003 (Robert Johnson)",
      receiver: "1005 (Michael Brown)",
      date: "2026-07-20 15:20:00",
      duration: "08m 45s",
      fileSize: "8.4 MB",
      url: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3"
    },
    {
      id: "rec-004",
      recordingName: "rec_98416_1001_inbound.mp3",
      caller: "+1 (555) 777-3311",
      receiver: "1001 (John Doe)",
      date: "2026-07-20 14:50:00",
      duration: "06m 10s",
      fileSize: "5.8 MB",
      url: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-4.mp3"
    },
    {
      id: "rec-005",
      recordingName: "rec_98414_1008_inbound.mp3",
      caller: "+1 (555) 111-2222",
      receiver: "1008 (David Miller)",
      date: "2026-07-20 14:15:00",
      duration: "10m 30s",
      fileSize: "10.1 MB",
      url: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-5.mp3"
    }
  ]
};
